import React, { useEffect, useState } from "react";

import { Box, Button, Typography } from "@mui/material";
import { Category, fetchCategory } from "lib/features/category/categoryService";

import AllIcon from "../../assets/icons/business_all.svg";
import AllIconFilled from "../../assets/icons/business_all_filled.svg";

import BoatIcon from "../../assets/icons/business_boat.svg";
import BoatIconFilled from "../../assets/icons/business_boat_filled.svg";

import TransportIcon from "../../assets/icons/business_transport.svg";
import TransportIconFilled from "../../assets/icons/business_transport_filled.svg";

import TableIcon from "../../assets/icons/business_tables.svg";
import TableIconFilled from "../../assets/icons/business_tables_filled.svg";

import FoodIcon from "../../assets/icons/business_food.svg";
import FoodIconFilled from "../../assets/icons/business_food_filled.svg";

import SportIcon from "../../assets/icons/business_sport.svg";
import SportIconFilled from "../../assets/icons/business_sport_filled.svg";

import AttractionIcon from "../../assets/icons/business_attraction.svg";
import AttractionIconFilled from "../../assets/icons/business_attraction_filled.svg";

import ActivitiesIcon from "../../assets/icons/business_activities.svg";
import ActivitiesIconFilled from "../../assets/icons/business_activities_filled.svg";

import ToursIcon from "../../assets/icons/business_tour.svg";
import ToursIconFilled from "../../assets/icons/business_tour_filled.svg";

import HealthIcon from "../../assets/icons/business_health.svg";
import HealthIconFilled from "../../assets/icons/business_health_filled.svg";

import RentalsIcon from "../../assets/icons/business_rentals.svg";

import PartyIcon from "../../assets/icons/business_party.svg";
import PartyIconFilled from "../../assets/icons/business_party_filled.svg";

import EventSpaceIcon from "../../assets/icons/business_eventspace.svg";
import EventSpaceIconFilled from "../../assets/icons/business_eventspace_filled.svg";

import EventIcon from "../../assets/icons/business_events.svg";
import EventIconFilled from "../../assets/icons/business_events_filled.svg";

import AccomodationIcon from "../../assets/icons/business_accomodations.svg";
import AccomodationIconFilled from "../../assets/icons/business_accomodations_filled.svg";

import CateringIcon from "../../assets/icons/business_catering.svg";
import CateringIconFilled from "../../assets/icons/business_catering_filled.svg";

import BartendingIcon from "../../assets/icons/business_bartending.svg";
import BartendingIconFilled from "../../assets/icons/business_bartending_filled.svg";

import PhotoIcon from "../../assets/icons/business_photo.svg";
import PhotoIconFilled from "../../assets/icons/business_photo_filled.svg";

import MusicIcon from "../../assets/icons/business_music.svg";
import MusicIconFilled from "../../assets/icons/business_photo_filled.svg";

import DecorationIcon from "../../assets/icons/business_decoration.svg";
import DecorationIconFilled from "../../assets/icons/business_decoration_filled.svg";

import StagingIcon from "../../assets/icons/business_staging.svg";
import StagingIconFilled from "../../assets/icons/business_staging_filled.svg";

import SeatingIcon from "../../assets/icons/business_seating.svg";
import SeatingIconFilled from "../../assets/icons/business_seating_filled.svg";

import PrintIcon from "../../assets/icons/business_print.svg";
import PrintIconFilled from "../../assets/icons/business_print_filled.svg";

import SecurityIcon from "../../assets/icons/business_security.svg";
import SecurityIconFilled from "../../assets/icons/business_security_filled.svg";

import HairIcon from "../../assets/icons/business_hair.svg";
import HairIconFilled from "../../assets/icons/business_hair_filled.svg";

import RentalIcon from "../../assets/icons/business_rental.svg";
import RentalIconFilled from "../../assets/icons/business_rental_filled.svg";

import EntertainmentIcon from "../../assets/icons/business_entertainment.svg";
import EntertainmentIconFilled from "../../assets/icons/business_entertainment_filled.svg";

import { selectUser } from "lib/features/user/userSlice";
import { useSelector } from "react-redux";
import FavouriteIcon from "../../assets/icons/business_favourite.svg";
import FavouriteIconFilled from "../../assets/icons/business_favourite_filled.svg";

interface CategoryListProps {
  handleActiveCategory: (id: number, name: string, index: number) => void;
  activeCategoryIndex: number;
  categoryType?: number[];
}

const AllCategories: React.FC<CategoryListProps> = ({
  handleActiveCategory,
  activeCategoryIndex,
  categoryType,
}) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const user = useSelector(selectUser);

  const iconMap = {
    // hospitality icons mapping
    2: { unfilled: AllIcon, filled: AllIconFilled },
    3: { unfilled: BoatIcon, filled: BoatIconFilled },
    4: { unfilled: TransportIcon, filled: TransportIconFilled },
    5: { unfilled: TableIcon, filled: TableIconFilled },
    6: { unfilled: FoodIcon, filled: FoodIconFilled },
    7: { unfilled: SportIcon, filled: SportIconFilled },
    8: { unfilled: AttractionIcon, filled: AttractionIconFilled },
    9: { unfilled: ActivitiesIcon, filled: ActivitiesIconFilled },
    10: { unfilled: ToursIcon, filled: ToursIconFilled },
    11: { unfilled: HealthIcon, filled: HealthIconFilled },
    12: { unfilled: RentalsIcon, filled: RentalIconFilled },
    13: { unfilled: PartyIcon, filled: PartyIconFilled },
    14: { unfilled: EventSpaceIcon, filled: EventSpaceIconFilled },
    15: { unfilled: EventIcon, filled: EventIconFilled },
    16: { unfilled: AccomodationIcon, filled: AccomodationIconFilled },

    // event icons mapping
    17: { unfilled: EventSpaceIcon, filled: EventSpaceIconFilled },
    18: { unfilled: CateringIcon, filled: CateringIconFilled },
    19: { unfilled: BartendingIcon, filled: BartendingIconFilled },
    20: { unfilled: TransportIcon, filled: TransportIconFilled },
    21: { unfilled: PhotoIcon, filled: PhotoIconFilled },
    22: { unfilled: MusicIcon, filled: MusicIconFilled },
    23: { unfilled: DecorationIcon, filled: DecorationIconFilled },
    24: { unfilled: StagingIcon, filled: StagingIconFilled },
    25: { unfilled: SeatingIcon, filled: SeatingIconFilled },
    26: { unfilled: PrintIcon, filled: PrintIconFilled },
    27: { unfilled: SecurityIcon, filled: SecurityIconFilled },
    28: { unfilled: HairIcon, filled: HairIconFilled },
    29: { unfilled: RentalIcon, filled: RentalIconFilled },
    30: { unfilled: EntertainmentIcon, filled: EntertainmentIconFilled },

    // Fav category
    31: { unfilled: FavouriteIcon, filled: FavouriteIconFilled },
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        const categories = await fetchCategory(categoryType);
        setCategories(categories);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };

    getCategories();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        overflowX: "auto",
        whiteSpace: "nowrap",
        padding: "10px 0",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {" "}
      <Box
        sx={{
          display: "inline-flex",
          flexWrap: "nowrap",
          gap: "5px",
        }}
      >
        {categories &&
          categories?.length > 0 &&
          categories
            ?.filter((category: Category) => {
              if (category.id === 31 && !user.id) return false;
              return true;
            })
            ?.map((item: Category, index: number) => {
              const IconImage =
                activeCategoryIndex === index
                  ? iconMap[item.id as keyof typeof iconMap]?.filled
                  : iconMap[item.id as keyof typeof iconMap]?.unfilled;

              return (
                <Button
                  key={index}
                  onClick={() =>
                    handleActiveCategory(item.id, item.category, index)
                  }
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "100%",
                      width: "fit-content",
                    }}
                  >
                    <img
                      src={IconImage}
                      alt="category-image"
                      width={22}
                      height={22}
                    />

                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color:
                          activeCategoryIndex === index ? "#00954A" : "#000",
                      }}
                    >
                      {item?.category}
                    </Typography>
                  </Box>
                </Button>
              );
            })}
      </Box>
    </Box>
  );
};

export default AllCategories;
